import { Tooltip } from "@mui/material";


let scoreColours = [
  "#bdbdbd",
  "#fc0d5d",
  "#fc6d0d",
  "#fcc80d",
  "#69ad02",
  "#02ad05",
];

function DrawFeedback(props) {

  let fbDisplay = {};

  let { feedback } = props.attendance;

  if (!feedback) return <div></div>;

  if (feedback.length > 0 && feedback[0].id) {
    feedback.forEach((fb) => {
      for (const field in fb) {
        if (field === "id" || field === "score") {
        } else {
          fbDisplay[field] = fb[field];
        }
      }
    });
  } else {
    fbDisplay = feedback;
  }

  return (
    <div>
      {Object.keys(fbDisplay).map((f) => (
        <div
          key={props.attendance._id + [f]}
          className="feedback-scores"
          style={{
            backgroundColor: scoreColours[fbDisplay[f]],

            height: 27,
          }}
        >
          {[f]}
        </div>
      ))}
    </div>
  );
}

export default function AttendanceWidget(props) {
  let { attendance } = props;
  let notes = "";
  if (attendance.attendance > 1) notes = attendance.absentReason;
  if (attendance.attendance < 2)
    notes = !attendance.feedbackNotes
      ? attendance.notes
      : attendance.feedbackNotes;
  if(attendance.attendance===100) notes = attendance.cancelledReason
  return (
    <Tooltip title={notes}>
      <div
        className="attendance-widget"
        style={{
          background: getColor(attendance.attendance)
            
        }}
      >
        <div className="attendance-date">
          {new Date(attendance.tDate).fDate().substring(0,5)}
        </div>
         <div style={{ color: "white" }}>
        <AttendanceType attendance={attendance} />
        </div>
      </div>
    </Tooltip>
  );
}

function AttendanceType({ attendance }) {
  
  if (attendance.attendance > 1) return <Absent attendance={attendance} />
  if (attendance.attendance===-2) return "Makeup class"

  return <DrawFeedback attendance={attendance} />;
}

function getColor(attendance) {
  if (attendance === -2) return "DarkCyan";
  if (attendance === -1) return "limegreen"
  if (attendance === 1) return "#038722"
  if (attendance === 2) return "#ffae00"
  if (attendance === 3) return "#ff0055";
  
  if (attendance === 100) return "purple"
  return "black"
}

function Absent(props) {
  let { attendance } = props
  if (attendance.attendance === 100) return <div>{attendance.cancelledReason}</div>
  return <div>
    <div>{attendance.absentReason}</div>
    {/* {makeUpClass ? <MUClass makeUpClass={makeUpClass} student={attendance.student} />: <div>No makeup class</div>} */}
  </div>
}

/* function MUClass({makeUpClass,student}) {
  let attendance = makeUpClass.students.find(s => s.student === student)
  let att = "No info"
  if (attendance) {
    att="Attended"
    if (attendance.attendance === -1) att = "Late"
    if (attendance.attendance === 2) att = "Absent"
    if (attendance.attendance === 3) att = "No Show";
  }
    return (
      <div
        style={{
       
          color: "white",
          borderRadius: 10,
          padding:10,
          marginTop: 5,
          backdropFilter: "brightness(0.8)"
        }}
      >
     
          Make up class:
          <FormatDate value={makeUpClass.date} />
          <div>{att}</div>
   
      </div>
    );
} */